import ReactECharts from "echarts-for-react";
import "./../DashboardStyles.scss";
import LoadingOverlay from "react-loading-overlay-ts";
import ClipLoader from "react-spinners/ClipLoader";
import { getGaugeOption, getPieOption } from "../utils/EchartsUtils";
import { Statistics } from "./components/Statistics";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import {
  getPieData,
  getGaugeData,
  getStatisticsData,
  selectActiveDashboardComponent,
  selectCurrentFilteredDashboard,
  selectDataStatistics,
  selectLoadingStatisticsData,
  selectLoadingGaugeData,
  selectLoadingPieData,
  selectDataPie,
  selectDataGauge,
  changeActiveComponent,
  selectNameClient,
} from "../DashboardSlice";
import { changeCurrentProduct, selectRoles } from "../../../common/commonSlice";
import "./../DashboardStyles.scss";
import { IndicatorButton } from "./components/IndicatorButton";
import { ReactComponent as BarIcon } from "../../../../Assets/common/images/barGraphIcon.svg";
import { ReactComponent as AreaIcon } from "../../../../Assets/common/images/stackArea.svg";
import { ReactComponent as GaugeIcon } from "../../../../Assets/common/images/gauge.svg";

export const Indicators = () => {
  const dispatch = useAppDispatch();
  const loadingStatistics = useAppSelector(selectLoadingStatisticsData);
  const loadingGauge = useAppSelector(selectLoadingGaugeData);
  const loadingPie = useAppSelector(selectLoadingPieData);
  const activeComponent = useAppSelector(selectActiveDashboardComponent);
  const currentFilteredRequest = useAppSelector(selectCurrentFilteredDashboard);
  const dataStatistics = useAppSelector(selectDataStatistics);
  const pie = useAppSelector(selectDataPie);
  const gauge = useAppSelector(selectDataGauge);
  const nameClient = useAppSelector(selectNameClient);
  const roles = useAppSelector(selectRoles);
  const [isActive, setIsActive] = useState<boolean>(false);
  const [showGauge, setShowGauge] = useState<boolean>(false);
  const [showStackBar, setShowStackBar] = useState<boolean>(false);
  const [showStackArea, setShowStackArea] = useState<boolean>(false);
  const [graphs, setGraphs] = useState<
    { id: string; component: JSX.Element }[]
  >([]);

  const { gaugeData } = gauge || {};

  useEffect(() => {
    dispatch(changeCurrentProduct("Dashboard"));

    if (activeComponent != "Indicators") {
      dispatch(changeActiveComponent("Indicators"));
    }
  }, []);

  useEffect(() => {
    if (currentFilteredRequest) {
      dispatch(
        getStatisticsData({
          filter: currentFilteredRequest,
        })
      );

      dispatch(
        getPieData({
          filter: currentFilteredRequest,
        })
      );

      dispatch(
        getGaugeData({
          filter: currentFilteredRequest,
        })
      );
    }
  }, [currentFilteredRequest]);

  const graphGauge = (
    <LoadingOverlay
      active={loadingGauge === "pending"}
      spinner={<ClipLoader color="white" size="50px" />}
      className="overlay"
    >
      {gaugeData ? (
        <div className="container-gauge">
          {gaugeData.map((item, index) => (
            <div className="gauge" key={index}>
              <div className="gauge-title-indicators" key={item.title}>
                {item.title}
              </div>
              <ReactECharts
                option={getGaugeOption({
                  title: item.title,
                  scoreIndicator: item.score,
                  deferenceIndicator: item.difference,
                  scoreUmbral: item.success_users,
                  deferenceUmbral: item.difference_success_users,
                })}
                style={{ height: "370px", width: "100%" }}
              />
            </div>
          ))}
        </div>
      ) : (
        <div
          className="text-xx-medium text-bold primary-color"
          style={{ textAlign: "center", padding: "200px" }}
        >
          <span>No hay datos disponibles</span>
        </div>
      )}
    </LoadingOverlay>
  );

  const graphStackBar = <div>Gráfico StackBar</div>;

  const graphStackArea = <div>Gráfico StackArea</div>;

  const toggleGraph = (graphType: string, graphComponent: JSX.Element) => {
    setGraphs((prev) => {
      const exists = prev.find((graph) => graph.id === graphType);
      if (exists) {
        return prev.filter((graph) => graph.id !== graphType);
      } else {
        return [...prev, { id: graphType, component: graphComponent }];
      }
    });

    switch (graphType) {
      case "gauge":
        setShowGauge((prev) => !prev);
        break;
      case "stackBar":
        setShowStackBar((prev) => !prev);
        break;
      case "stackArea":
        setShowStackArea((prev) => !prev);
        break;
      default:
        break;
    }
  };

  const handleGaugeClick = () => toggleGraph("gauge", graphGauge);
  const handleStackBarClick = () => toggleGraph("stackBar", graphStackBar);
  const handleStackAreaClick = () => toggleGraph("stackArea", graphStackArea);

  return (
    <div className="container-indicators">
      <div className="gauge-title">
        <span>
          Indicadores factores de verificación{" "}
          {nameClient && `de : ${nameClient}`}
        </span>
      </div>

      <div className="container-header">
        <LoadingOverlay
          active={loadingStatistics === "pending"}
          spinner={<ClipLoader color="white" size="60px" />}
        >
          {dataStatistics ? (
            <div className="header-registrations">
              {dataStatistics?.statisticsData.map((item, index) => (
                <Statistics key={item.title} {...item} />
              ))}
            </div>
          ) : (
            <div
              className="text-xx-medium text-bold primary-color"
              style={{ textAlign: "center" }}
            >
              <span></span>
            </div>
          )}
        </LoadingOverlay>

        <div className="header-pie">
          <div className="btns-options">
            <div className="btn-container">
              <button
                type="button"
                className={`btn-indicators ${!isActive ? "active" : ""}`}
                onClick={() => {
                  setIsActive(false);
                }}
              >
                #
              </button>
            </div>
            <div className="btn-container">
              <button
                type="button"
                className={`btn-indicators ${
                  isActive ? "active" : ""
                } btn-indicators-second`}
                onClick={() => {
                  setIsActive(true);
                }}
              >
                %
              </button>
            </div>
          </div>

          <div className="echartsPie">
            <LoadingOverlay
              active={loadingPie === "pending"}
              spinner={<ClipLoader color="white" size="50px" />}
            >
              {pie?.data.datanotfound == 0 ? (
                <div
                  className="text-xx-medium text-bold primary-color"
                  style={{ textAlign: "center", padding: "83px" }}
                >
                  <span>No hay datos disponibles</span>
                </div>
              ) : (
                pie &&
                pie.data.dataPie.length > 0 && (
                  <ReactECharts
                    option={getPieOption(isActive, pie.data.dataPie)}
                    style={{ height: "230px", width: "100%" }}
                  />
                )
              )}
            </LoadingOverlay>
          </div>
        </div>
      </div>

      {roles.includes("dashboard.internal.admin") && (
        <div className="d-flex align-align-items-center mb-2 mt-2">
          <IndicatorButton
            isActive={showGauge}
            onClick={handleGaugeClick}
            label="gráfico gauge"
            icon={<GaugeIcon />}
            isLeft
          />
          <IndicatorButton
            isActive={showStackBar}
            onClick={handleStackBarClick}
            label="gráfico stackbar"
            icon={<BarIcon />}
          />
          <IndicatorButton
            isActive={showStackArea}
            onClick={handleStackAreaClick}
            label="gráfico stackarea"
            icon={<AreaIcon />}
            isRight
          />
        </div>
      )}
      {roles.includes("dashboard.internal.admin") ? (
        graphs.length > 0 ? (
          graphs.map((graph) => <>{graph.component}</>)
        ) : (
          <div className="h-50 d-flex justify-content-center align-items-center">
            <p className="text-white font-bold">
              Seleccione los gráficos que desee visualizar.
            </p>
          </div>
        )
      ) : (
        graphGauge
      )}
    </div>
  );
};
